import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Filter out extension-related errors and Google Translate errors
    const errorMessage = error?.message || error?.toString() || '';
    const errorStack = error?.stack || '';
    
    if (
      errorMessage.includes('showPopover') ||
      errorMessage.includes('removeChild') ||
      errorMessage.includes('Invalid URL') ||
      errorMessage.includes('canvas.js') ||
      errorMessage.includes('overlay.js') ||
      errorMessage.includes('simulator.js') ||
      errorMessage.includes('translate.googleapis.com') ||
      errorMessage.includes('translate_http') ||
      errorMessage === 'Script error.' ||
      errorMessage.includes('TranslateElement') ||
      errorMessage.includes('translate') ||
      errorStack.includes('translate.googleapis.com') ||
      errorStack.includes('translate_http') ||
      errorStack.includes('TranslateElement') ||
      errorStack.includes('_.k.Yh') ||
      errorStack.includes('_.k.ja') ||
      errorStack.includes('_.k.ph') ||
      errorStack.includes('_.k.uf')
    ) {
      // Don't show error boundary for extension/Google Translate errors
      return null;
    }
    
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Filter out extension-related errors and Google Translate errors
    const errorMessage = error?.message || error?.toString() || '';
    const errorStack = error?.stack || '';
    const errorInfoStr = errorInfo?.componentStack || '';
    
    if (
      errorMessage.includes('showPopover') ||
      errorMessage.includes('removeChild') ||
      errorMessage.includes('Invalid URL') ||
      errorMessage.includes('canvas.js') ||
      errorMessage.includes('overlay.js') ||
      errorMessage.includes('simulator.js') ||
      errorMessage.includes('translate.googleapis.com') ||
      errorMessage.includes('translate_http') ||
      errorMessage === 'Script error.' ||
      errorMessage.includes('TranslateElement') ||
      errorMessage.includes('translate') ||
      errorStack.includes('translate.googleapis.com') ||
      errorStack.includes('translate_http') ||
      errorStack.includes('TranslateElement') ||
      errorStack.includes('_.k.Yh') ||
      errorStack.includes('_.k.ja') ||
      errorStack.includes('_.k.ph') ||
      errorStack.includes('_.k.uf') ||
      errorInfoStr.includes('translate')
    ) {
      // Suppress these errors
      return;
    }
    
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '8px',
          margin: '20px',
        }}>
          <h2>Something went wrong.</h2>
          <p>Please refresh the page or try again later.</p>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
